import Title from "./Title";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import apiService from "../../Services/apiService";
import Loading from "../General/Loading";
import PopupGlobel from "../../PopModal/PopupGlobel";
import { Shredder } from "lucide-react";
const MngBranches = () => {
  const [loading, setLoading] = useState(false);
  const [navParams] = useSearchParams();
  const [areas, setAreas] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [idUpdate, setIdUpdate] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [branchCode, setBranchCode] = useState("");
  const [mobile, setMobile] = useState("");
  const [tel, setTel] = useState("");
  const [latLong, setLatLong] = useState("");
  const [status, setStatus] = useState("نشط");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState(null);
  const [area, setArea] = useState(null);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [isShowPopAdd, setIsShowPopAdd] = useState(false);
  const [errName, setErrName] = useState("");
  const [errCode, setErrCode] = useState("");
  const [errArea, setErrArea] = useState("");
  const [errCity, setErrCity] = useState("");
  const [errShopId, setErrShopId] = useState("");
  const [errAddress, setErrAdress] = useState("");
  const [errLatLong, setErrLatLong] = useState("");
  const [errMobile, setErrMobile] = useState("");
  const [shops, setShops] = useState<any[]>([]);
  const [shopId, setShopId] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    fetshAreas();
    fetshShops();
    const no = navParams.get("no");
    if (no != null) {
      setIdUpdate(no);
      fetchData(no);
    }
  }, []);
  const fetshShops = async (): Promise<void> => {
    try {
      setLoading(true);
      const result = await apiService.fetchGetData("api/GetShops", {});
      setShops(result.data);
    } catch (error) {
      console.error("Error fetching tags:", error);
      setShops([]); // Handle error case
    }
    setLoading(false);
  };
  const fetshAreas = async (): Promise<void> => {
    try {
      setLoading(true);
      const result = await apiService.fetchGetData("api/GetCitiesAndAreas", {});
      setAreas(result.areas);
      setCities(result.cities);
    } catch (error) {
      console.error("Error fetching tags:", error);
      setAreas([]);
      setCities([]);
      // Handle error case
    }
    setLoading(false);
  };
  const fetchData = async (no: any) => {
    try {
      const result = await apiService.fetchGetData("api/GetBranchByNo", {
        no: no,
      });
      debugger;
      if (result[0]) {
        setName(result[0].branchName);
        setAddress(result[0].adderss);
        setBranchCode(result[0].code);
        setMobile(result[0].mobile);
        setTel(result[0].tel);
        setStatus(result[0].status);
        setLatLong(result[0].lat + "," + result[0].long);
        setEmail(result[0].email);
        setContactPerson(result[0].contactPerson);
        setShopId(result[0].shopId);
        setCity(result[0].city);
        setArea(result[0].area);
        //         setCity(
        // optionsCities.find(item => item.value === result[0].city)?.value
        // );
        //     setArea(
        // optionsAreas.find(item => item.value === result[0].area)?.value
        // );
      }
    } catch (error) {
      console.error(error);
    }
  };
  const addData = async () => {
    try {
      setLoading(true);
      debugger;
      const result =
        idUpdate != null && idUpdate !== ""
          ? await apiService.fetchData("api/AddBranch", {
              branchId: idUpdate,
              branchName: name,
              code: branchCode,
              mobile: mobile,
              tel: tel,
              email: email,
              fax: "fax",
              adderss: address,
              city: city,
              area: area,
              contactPerson: contactPerson,
              lat: latLong.split(",")[0],
              long: latLong.split(",")[1],
              shopId: String(shopId),
              status: status,
            })
          : await apiService.fetchData("api/AddBranch", {
              branchName: name,
              code: branchCode,
              mobile: mobile,
              tel: tel,
              email: email,
              fax: "fax",
              adderss: address,
              city: city,
              area: area,
              contactPerson: contactPerson,
              lat: latLong.split(",")[0],
              long: latLong.split(",")[1],
              shopId: String(shopId),
              status: status,
            });
      if (result.isOk) {
        setSuccess("✅" + result.errAr);
      } else setError("❌" + result.errAr);
      setIsShowPopAdd(false);
      setLoading(false);
      return result;
    } catch (error) {
      setError("❌" + error);
      setIsShowPopAdd(false);
      setLoading(false);
      return null;
    }
  };
  const handleSubmit = () => {
    if (validateForm()) {
      addData();
    } else {
      setError("راجع مدخلات الحقول");
    }
  };
  const validateForm = () => {
    let isValidate = true;
    if (name.trim() === "") {
      isValidate = false;
      setErrName("إدخل الاسم");
    } else {
      setErrName("");
    }
    if (branchCode.trim() === "") {
      isValidate = false;
      setErrCode("إدخل معرف الفرع  ");
    } else {
      setErrCode("");
    }
    if (address.trim() === "") {
      isValidate = false;
      setErrAdress("إدخل العنوان  ");
    } else {
      setErrAdress("");
    }
    if (area === null || area === "") {
      isValidate = false;
      setErrArea("اختر المنطقة  ");
    } else {
      setErrArea("");
    }
    if (shopId === null || shopId === "") {
      isValidate = false;
      setErrShopId("اختر المتجر  ");
    } else {
      setErrShopId("");
    }
    if (city === null || city === "") {
      isValidate = false;
      setErrCity("اختر المدينة  ");
    } else {
      setErrCity("");
    }
    if (latLong.trim() === "") {
      isValidate = false;
      setErrLatLong("ادخل خط الطول والعرض");
    } else {
      setErrLatLong("");
    }
    return isValidate;
  };
  const options = shops.map((item) => ({
    value: item.shopId,
    label: item.portName,
    data: item, // keep the whole object
  }));
  const optionsAreas = areas.map((item) => ({
    value: item,
    label: item,
    data: item, // keep the whole object
  }));
  const optionsCities = cities.map((item) => ({
    value: item,
    label: item,
    data: item, // keep the whole object
  }));
  const handleChange = (option: any) => {
    if (option != null) {
      setLoading(true);
      setShopId(option.value);
      setLoading(false);
    } else {
      setShopId(null);
    }
  };
  const handleChangeArea = (option: any) => {
    if (option != null) {
      setLoading(true);
      setArea(option.value);
      setLoading(false);
    } else {
      setArea(null);
    }
  };
  const handleChangeCity = (option: any) => {
    if (option != null) {
      setLoading(true);
      setCity(option.value);
      setLoading(false);
    } else {
      setCity(null);
    }
  };
  return (
    <>
      {loading && <Loading />}
      {isShowPopAdd && (
        <PopupGlobel
          approveAction={() => handleSubmit()}
          cancelAction={() => {
            setIsShowPopAdd(false);
          }}
          btnApproveTitle="حفظ"
          btnCancelTitle="الغاء"
          title="تاكيد الحفظ"
          popupType={1}
        >
          <p>هل انت متاكد من حفظ البيانات؟ </p>
        </PopupGlobel>
      )}
      <main className="relative pt-16 min-h-screen bg-surface">
        <div className="flex flex-col w-full h-full p-margin-desktop gap-gutter max-w-[1200px] mx-auto">
          <Title
            pageName=" إدارة فروع المتاجر"
            pageDesc=""
            isSearch={false}
            isAdd={true}
            btnIcon="filter_list"
            addEvent={() => navigate("/admin/filterBranches")}
            AddText="عرض قائمة فروع المتاجر"
          />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            {/* Main Content Area */}
            <div className="lg:col-span-12 flex flex-col gap-8">
              {/* Profile Settings */}
              <section
                className="bg-surface-container-lowest rounded-2xl p-8 shadow-sm"
                id="profile"
              >
                {error && (
                  <div className="bg-red-100 text-red-700 p-4 rounded-lg">
                    {error}
                  </div>
                )}
                {success && (
                  <div className="bg-green-100 text-green-700 p-4 rounded-lg">
                    {success}
                  </div>
                )}
                <div className="flex items-center gap-4 mb-8 pb-4 border-b border-surface-container-highest">
                  <span className="material-symbols-outlined text-[28px] text-primary">
                    person
                  </span>
                  <h2 className="font-headline-md text-headline-md text-on-surface">
                    إدارة فروع المتاجر
                  </h2>
                </div>
                <div className="flex flex-col md:flex-row gap-8">
                  <div className="w-full md:w-2/3 flex flex-col gap-6">
                    <div className="flex flex-col gap-2">
                      <label className="font-label-md text-label-md text-on-surface-variant">
                        اسم المتجر
                        {errShopId !== "" ? (
                          <span
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            {errShopId}
                          </span>
                        ) : (
                          ""
                        )}
                      </label>
                      <Select
                        options={options}
                        placeholder="🔍 حدد المتجر "
                        isSearchable
                        isClearable
                        value={options.find(
                          (option) => option.value === shopId,
                        )}
                        isMulti={false}
                        menuPlacement="auto"
                        onChange={handleChange}
                        noOptionsMessage={() => "No results found"}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: "50px",
                            borderRadius: "12px",
                            borderColor: state.isFocused
                              ? "#3B82F6"
                              : "#E5E7EB",
                            boxShadow: state.isFocused
                              ? "0 0 0 3px rgba(59,130,246,0.2)"
                              : "none",
                            "&:hover": {
                              borderColor: "#3B82F6",
                            },
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected
                              ? "#3B82F6"
                              : state.isFocused
                                ? "#EFF6FF"
                                : "white",
                            color: state.isSelected ? "white" : "#111827",
                            cursor: "pointer",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            borderRadius: "12px",
                            overflow: "hidden",
                          }),
                        }}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="font-label-md text-label-md text-on-surface-variant">
                        اسم الفرع
                        {errName !== "" ? (
                          <span
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            {errName}
                          </span>
                        ) : (
                          ""
                        )}
                      </label>
                      <input
                        className="bg-surface px-4 py-3 rounded-lg font-body-md text-body-md text-on-surface focus:outline-none focus:ring-2 focus:ring-primary shadow-inner"
                        type="text"
                        defaultValue=""
                        maxLength={250}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="font-label-md text-label-md text-on-surface-variant">
                        رقم عقد المتجر
                        {errCode !== "" ? (
                          <span
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            {errCode}
                          </span>
                        ) : (
                          ""
                        )}
                      </label>
                      <input
                        className="bg-surface px-4 py-3 rounded-lg font-body-md text-body-md text-on-surface focus:outline-none focus:ring-2 focus:ring-primary shadow-inner"
                        type="text"
                        defaultValue=""
                        maxLength={250}
                        value={branchCode}
                        onChange={(e) => {
                          const value = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 4);
                          setBranchCode(value);
                        }}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="font-label-md text-label-md text-on-surface-variant">
                        الاحداثيات
                        {errLatLong !== "" ? (
                          <span
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            {errLatLong}
                          </span>
                        ) : (
                          ""
                        )}
                      </label>
                      <input
                        className="bg-surface px-4 py-3 rounded-lg font-body-md text-body-md text-on-surface focus:outline-none focus:ring-2 focus:ring-primary shadow-inner"
                        type="text"
                        defaultValue=""
                        maxLength={250}
                        value={latLong}
                        onChange={(e) => setLatLong(e.target.value)}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="font-label-md text-label-md text-on-surface-variant">
                        الايميل
                      </label>
                      <input
                        className="bg-surface px-4 py-3 rounded-lg font-body-md text-body-md text-on-surface focus:outline-none focus:ring-2 focus:ring-primary shadow-inner"
                        type="text"
                        defaultValue=""
                        maxLength={250}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      {errArea !== "" ? (
                        <span
                          style={{
                            color: "red",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                        >
                          {errArea}
                        </span>
                      ) : (
                        ""
                      )}
                      <Select
                        options={optionsAreas}
                        placeholder="🔍 حدد المنطقة "
                        isSearchable
                        isClearable
                        value={optionsAreas.find(
                          (option) => option.value === area,
                        )}
                        isMulti={false}
                        menuPlacement="auto"
                        onChange={handleChangeArea}
                        noOptionsMessage={() => "No results found"}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: "50px",
                            borderRadius: "12px",
                            borderColor: state.isFocused
                              ? "#3B82F6"
                              : "#E5E7EB",
                            boxShadow: state.isFocused
                              ? "0 0 0 3px rgba(59,130,246,0.2)"
                              : "none",
                            "&:hover": {
                              borderColor: "#3B82F6",
                            },
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected
                              ? "#3B82F6"
                              : state.isFocused
                                ? "#EFF6FF"
                                : "white",
                            color: state.isSelected ? "white" : "#111827",
                            cursor: "pointer",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            borderRadius: "12px",
                            overflow: "hidden",
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-full md:w-2/3 flex flex-col gap-6">
                    <div className="flex flex-col gap-2">
                      <label className="font-label-md text-label-md text-on-surface-variant">
                        العنوان
                        {errAddress !== "" ? (
                          <span
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            {errAddress}
                          </span>
                        ) : (
                          ""
                        )}
                      </label>
                      <input
                        className="bg-surface px-4 py-3 rounded-lg font-body-md text-body-md text-on-surface focus:outline-none focus:ring-2 focus:ring-primary shadow-inner"
                        type="text"
                        defaultValue=""
                        maxLength={250}
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="font-label-md text-label-md text-on-surface-variant">
                        مسوول التواصل
                      </label>
                      <input
                        className="bg-surface px-4 py-3 rounded-lg font-body-md text-body-md text-on-surface focus:outline-none focus:ring-2 focus:ring-primary shadow-inner"
                        type="text"
                        defaultValue=""
                        maxLength={250}
                        value={contactPerson}
                        onChange={(e) => setContactPerson(e.target.value)}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="font-label-md text-label-md text-on-surface-variant">
                        رقم الجوال
                        {errMobile !== "" ? (
                          <span
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            {errMobile}
                          </span>
                        ) : (
                          ""
                        )}
                      </label>
                      <input
                        className="bg-surface px-4 py-3 rounded-lg font-body-md text-body-md text-on-surface focus:outline-none focus:ring-2 focus:ring-primary shadow-inner"
                        type="text"
                        defaultValue=""
                        maxLength={250}
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="font-label-md text-label-md text-on-surface-variant">
                        رقم الهاتف
                      </label>
                      <input
                        className="bg-surface px-4 py-3 rounded-lg font-body-md text-body-md text-on-surface focus:outline-none focus:ring-2 focus:ring-primary shadow-inner"
                        type="text"
                        defaultValue=""
                        maxLength={250}
                        value={tel}
                        onChange={(e) => setTel(e.target.value)}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      {errCity !== "" ? (
                        <span
                          style={{
                            color: "red",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                        >
                          {errCity}
                        </span>
                      ) : (
                        ""
                      )}
                      <Select
                        options={optionsCities}
                        placeholder="🔍 حدد المدينة "
                        isSearchable
                        isClearable
                        isMulti={false}
                        value={optionsCities.find(
                          (option) => option.value === city,
                        )}
                        menuPlacement="auto"
                        onChange={handleChangeCity}
                        noOptionsMessage={() => "No results found"}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: "50px",
                            borderRadius: "12px",
                            borderColor: state.isFocused
                              ? "#3B82F6"
                              : "#E5E7EB",
                            boxShadow: state.isFocused
                              ? "0 0 0 3px rgba(59,130,246,0.2)"
                              : "none",
                            "&:hover": {
                              borderColor: "#3B82F6",
                            },
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected
                              ? "#3B82F6"
                              : state.isFocused
                                ? "#EFF6FF"
                                : "white",
                            color: state.isSelected ? "white" : "#111827",
                            cursor: "pointer",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            borderRadius: "12px",
                            overflow: "hidden",
                          }),
                        }}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="text-xs font-semibold text-on-surface-variant flex items-center gap-1">
                        الحالة
                      </label>
                      <div className="relative">
                        <select
                          value={status}
                          onChange={(e) => setStatus(e.target.value)}
                          className="w-full bg-surface-container-low border border-outline-variant/40 rounded-xl px-3 py-2 text-body-sm text-on-surface outline-none focus:border-vibrant-orange transition-all appearance-none cursor-pointer pr-3 pl-8"
                        >
                          <option value="نشط"> نشط</option>
                          <option value="مقفل"> مقفل</option>
                        </select>
                        <span className="material-symbols-outlined absolute left-2.5 top-1/2 -translate-y-1/2 text-on-surface-variant text-base pointer-events-none">
                          expand_more
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-end mt-2">
                      <button
                        onClick={() => {
                          setName("");
                          setBranchCode("");
                          setContactPerson("");
                          setAddress("");
                          setEmail("");
                          setMobile("");
                          setTel("");
                          setCity(null);
                          setArea(null);
                          setShopId(null);
                          setError("");
                          setSuccess("");
                          setIdUpdate("");
                          navigate("/admin/mngBranches");
                        }}
                        className="rounded-full shadow-sm bg-surface text-on-surface hover:bg-surface/90  font-label-md px-6 py-2  transition-al"
                      >
                        <span className=""> جديد</span>
                      </button>
                      <button
                        style={{ marginRight: "2px" }}
                        onClick={() => {
                          if (validateForm()) {
                            setIsShowPopAdd(true);
                          } else {
                            setError("راجع مدخلات الحقول");
                          }
                        }}
                        className="rounded-full shadow-sm bg-primary text-on-primary hover:bg-primary/90  font-label-md px-6 py-2  transition-al"
                      >
                        إضافة
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default MngBranches;
